module.exports = "/_next/static/images/a05cd76f7ce89bb046b00c36b8c2f083-cartao-proximo-ao-olho-lg@1x.jpg";